<template comments>
  <div class="intro-box">
    <div class="intro-box-head">
      流程如下
    </div>

    <p>
      <strong class="intro-box-tit">步骤1</strong>
    </p>
    <p>
      在Nintendo Switch上通过主页菜单中的“Nintendo e商店”图标进入Nintendo
      e商店；
    </p>
    <p>
      <img src="@/assets/img/index/img01.png" alt="" />
    </p>

    <p>
      <strong class="intro-box-tit">步骤2</strong>
    </p>
    <p>
      选取参与活动的游戏，在游戏详情页中选择“开始购买”。在确认您需要购买的内容后，选择“使用微信支付结算”{{
        showPay ? '；' : '。'
      }}
    </p>
    <p>
      <img src="@/assets/img/index/img02.png" alt="" />
    </p>

    <template v-if="showPay">
      <p>
        <strong class="intro-box-tit">步骤3</strong>
      </p>
      <p>
        此时会进入“微信支付“的页面，选择”立即支付”；
      </p>
      <p>
        <img src="@/assets/img/index/img03.png" style="width: 60%;" alt="" />
      </p>

      <p>
        <strong class="intro-box-tit">步骤4</strong>
      </p>
      <p>
        若已领取相关代金券，会自动使用对应代金券（您也可以选择其他希望使用的优惠券），并在“优惠”一栏显示优惠金额，选择“确认支付”完成支付。
      </p>
      <p>
        <img src="@/assets/img/index/img04.png" style="width: 60%;" alt="" />
      </p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    showPay: {
      type: Boolean,
      default: true
    }
  }
};
</script>
